import { render } from "./ContentPanel.vue?vue&type=template&id=ecd5a9bc"
import script from "./ContentPanel.vue?vue&type=script&lang=js"
export * from "./ContentPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/ContentPanel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ecd5a9bc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ecd5a9bc', __exports__)) {
    api.reload('ecd5a9bc', __exports__)
  }
  
  module.hot.accept("./ContentPanel.vue?vue&type=template&id=ecd5a9bc", () => {
    api.rerender('ecd5a9bc', render)
  })

}


export default __exports__